/** Recipient normalisation for the catalogue item-request mail.
 *
 * Its own module rather than a helper inside the modal: exporting a function
 * beside a component costs fast refresh, and this is the piece the tests care
 * about most — it decides what address a typed name turns into.
 */

/** Appended when a reviewer types a bare name instead of an address. */
const DEFAULT_RECIPIENT_DOMAIN = "tecalliance.net";

/**
 * Normalise one typed recipient.
 *
 * A bare `huy.pham` becomes `huy.pham@tecalliance.net` — the address everyone
 * here has — while anything already carrying an `@` is left alone, so a partner
 * address (`...@partners.tecalliance.net`) or an external maintainer stays
 * reachable. Convenience only: what a deployment may actually address is
 * decided server-side by `MAPPING_MAIL_ALLOWED_DOMAINS`, and a wrong guess here
 * comes back as a 400 rather than a silent send.
 */
export const normaliseRecipient = (raw: string): string => {
  const trimmed = raw.trim().toLowerCase();
  if (!trimmed) return "";
  return trimmed.includes("@")
    ? trimmed
    : `${trimmed}@${DEFAULT_RECIPIENT_DOMAIN}`;
};
